// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "" + ({"4":"banner-lazy","40":"cookie-policy"}[chunkId] || chunkId) + ".lite.js?ver=" + {"4":"dd08ccbdb20ae2c3","40":"34246544b898bf20","227":"eb91502fb5aa9e2c","343":"a12327ef46b2b83a"}[chunkId] + "";
};